/**
 * created by wang lei

 *
 */
import React, {Component} from 'react';
import SelectBtn from "./selectBtn";
import {Icon} from "antd";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class SelectTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options:props.options,
            configKey: props.configKey,
            configKeyTwo:props.configKeyTwo,
            imgUrl: props.imgUrl,
            defaultOption: props.defaultOption,
            visible: false,
            checkedOption: '',
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.configKey != this.state.configKey) {
            this.setState({
                options:nextProps.options,
                configKey: nextProps.configKey,
                imgUrl: nextProps.imgUrl,
                defaultOption: nextProps.defaultOption,
                configKeyTwo:nextProps.configKeyTwo,
            })
        }
    }

    render() {
        const {imgUrl,options} =this.state;
        return (
            <div style={{cursor:"pointer",position: 'relative'}}>
                <img src={imgUrl} onClick={()=>{
                    this.clickImg()
                    if (typeof this.props.onClickCall == 'function') {
                        this.props.onClickCall(true)
                    }
                }}/>
                <SelectBtn
                    ref={ref=>this.selectBtn=ref}
                    options={options}
                    visible={this.state.visible}
                    hide={()=>{this.hide()}}
                    onChange={(key)=>{
                        this.checkOption(key)
                    }}
                >
                    <Icon type="caret-down" onClick={()=>{
                        this.setState({visible:true})}}/>
                </SelectBtn>
            </div>
        )
    }

    checkOption(key) {
        this.state.options.forEach((option, index)=>{
            if(option.key == key) {
                this.state.options[index].checked = !this.state.options[index].checked;
                if(this.state.options[index].checked) {
                    this.state.checkedOption=this.state.options[index].key;
                }
            } else {
                this.state.options[index].checked = false
            }
        });
        this.setState({},()=>{
            this.insertunorderedlist()
        })
    };

    insertunorderedlist(call) {
        const {configKey,configKeyTwo} =this.state;
        let {checkedOption} = this.state;
        this.props.editor.execCommand(configKey,checkedOption,configKeyTwo);
        call && call()
    }

    clickImg() {
        const {configKey,defaultOption,configKeyTwo} =this.state;
        if(!this.state.checkedOption) {
            this.state.checkedOption = defaultOption;
        }
        let state = this.props.editor.queryCommandValue(configKey,configKeyTwo); // circle,disc,square,dash,dot
        if(state == null) {
            this.checkOption(this.state.checkedOption);
        } else {
            this.props.options.forEach((option, index)=>{
                this.props.options[index].checked = false;
            });
            this.insertunorderedlist(()=>{
                this.state.checkedOption = "";
            });
        }
    }

    hide() {
        this.setState({visible:false})
    }

}

